import React from 'react';
import { Grid, Box, HStack, Spacer, Select } from '@chakra-ui/react';
import { i18n } from '../../../i18n/translate.js';
import { FilterTableInput } from './utils/input-filters.js';
var TablePaginationHeader = function TablePaginationHeader(_ref) {
  var table = _ref.table,
    filterTable = _ref.filterTable,
    globalFilter = _ref.globalFilter,
    setGlobalFilter = _ref.setGlobalFilter,
    activePageState = _ref.activePageState,
    pagingInfo = _ref.pagingInfo,
    initialValue = _ref.initialValue;
  var totalCount = table.getRowCount();
  var pagination = table.getState().pagination;
  var activePage = activePageState && activePageState > 0 ? activePageState : 1;
  var previousItemCount = table.getState().pagination.pageSize * (activePage - 1);
  var dataSize = pagingInfo ? pagingInfo.dataSize : pagination.pageSize;
  var onChangeEvent = function onChangeEvent(e) {
    table.setPageSize(Number(e.target.value));
  };
  var itemsPerPageOptions = [20, 50, 100, 200];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    justifyContent: 'flex-end'
  }, filterTable && setGlobalFilter ? /*#__PURE__*/React.createElement(FilterTableInput, {
    value: globalFilter !== null && globalFilter !== undefined ? globalFilter : '',
    onChange: function onChange(value) {
      return setGlobalFilter(String(value));
    },
    placeholder: initialValue
  }) : ''), /*#__PURE__*/React.createElement(Box, {
    paddingY: 4
  }, /*#__PURE__*/React.createElement(HStack, {
    spacing: '50px'
  }, /*#__PURE__*/React.createElement("span", null, table.getPageCount() > 1 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "bold"
  }, i18n.t('Results: ')), i18n.t('%s of %s', {
    postProcess: 'sprintf',
    sprintf: ["".concat(previousItemCount + 1, " - ").concat(previousItemCount + dataSize > totalCount ? totalCount : previousItemCount + dataSize), totalCount]
  })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "bold"
  }, i18n.t('Results:')), " ", totalCount)), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement("span", {
    className: "bold"
  }, i18n.t('Items Per Page:')), /*#__PURE__*/React.createElement(Select, {
    value: table.getState().pagination.pageSize,
    onChange: function onChange(e) {
      return onChangeEvent(e);
    },
    size: "sm",
    width: "75x"
  }, itemsPerPageOptions.map(function (pageSize) {
    return /*#__PURE__*/React.createElement("option", {
      key: pageSize,
      value: pageSize,
      style: {
        background: 'white'
      }
    }, pageSize);
  })))))));
};
export { TablePaginationHeader };